import React, { Component } from 'react';

class AboutV1 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + '/';

    return (
      <div id='quisommesnous' className="ltn__about-us-area pt-120 pb-90 ">
        <div className="container">
          <div className="row">
            {/* Image à gauche */}
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img src="/assets/img/23.jpg" alt="Medesco Immobilier" />
                {/* <img src={publicUrl + "assets/img/others/7.png"} alt="Medesco Immobilier" /> */}
                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
                  <div className="ltn__video-img ltn__animation-pulse1">
                    {/* <img src={publicUrl + "assets/img/others/8.png"} alt="video popup bg image" /> */}
                    {/* <a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
                      <i className="fa fa-play" />
                    </a> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Texte à droite */}
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">À propos de Medesco</h6>
                  <h1 className="section-title">
                    Medesco : Excellence et Confiance<span>.</span>
                  </h1>
                  <p>
                    Medesco est une entreprise marocaine spécialisée dans la promotion et la vente de biens résidentiels et commerciaux aux finitions haut standing. Filiale d’un groupe de référence, Medesco s’appuie sur plus de 17 ans d’expertise dans la construction et les équipements énergétiques pour imaginer des espaces modernes, accessibles et conçus pour votre bien-être. Chaque projet Medesco se distingue par une architecture soignée, des standards élevés de sécurité et un confort de vie incomparable. Votre satisfaction guide chacune de nos réalisations.

Découvrez une nouvelle expérience de l’immobilier, où innovation, excellence et engagement se rencontrent pour faire de votre futur espace un lieu unique à vivre.
                  </p>
                </div>
                <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2" />
                    Qualité architecturale supérieure
                  </li>
                  <li>
                    <i className="flaticon-mountain" />
                    Emplacements privilégiés à Tanger
                  </li>
                  <li>
                    <i className="flaticon-heart" />
                    Accompagnement client sur-mesure
                  </li>
                  <li>
                    <i className="flaticon-secure" />
                    Sécurité et transparence garanties
                  </li>
                </ul>
                <div className="ltn__callout bg-overlay-theme-05  mt-30">
                  <p>
                    "Notre mission : vous accompagner dans la recherche de votre futur logement, en vous proposant des résidences bien situées, bien conçues et accessibles."
                  </p>
                </div>
                <div className="btn-wrapper animated go-top">
                  <a href="#projet" className="theme-btn-1 btn btn-effect-1">Nos projets</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutV1;
